import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center rounded-tr-2xl rounded-br-2xl w-12 h-12 bg-gray-100 dark:bg-gray-700 border-2 border-l-0 border-blue-700 dark:border-indigo-300 px-2 py-2 text-current hover:text-blue-900 dark:hover:text-indigo-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _createVNode(_component_font_awesome_icon, {
      icon: ['fas', 'search'],
      title: "Buscar",
      class: "fill-current"
    })
  ]))
}